import {
  animate, AUTO_STYLE,

  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, input, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';


export const DEFAULT_DURATION = 300;

@Component({
  selector: 'base-collapse',
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss'],
  standalone: true,
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  imports: [CommonModule]
})
export class CollapseComponent {
  readonly title = input<string>('');
  readonly collapsed = input<boolean>(false);

  // Internal state for managing collapse state
  private _isCollapsed = signal<boolean>(false);

  // Computed property to get the current collapsed state
  readonly isCollapsed = computed(() => {
    const inputCollapsed = this.collapsed();
    if (inputCollapsed !== undefined) {
      return inputCollapsed;
    }
    return this._isCollapsed();
  });

  toggle() {
    this._isCollapsed.set(!this._isCollapsed());
  }

  expand() {
    this._isCollapsed.set(false);
  }

  collapse() {
    this._isCollapsed.set(true);
  }
}

